import { memo } from 'react';

import { FooterLogos } from './FooterLogos';

export * from './FooterLogos';

export default memo(FooterLogos);
